module.exports = __webpack_public_path__ + "static/media/yes-icon.16161500.svg";